import { render, staticRenderFns } from "./LeagueModal.vue?vue&type=template&id=1f702d46&"
import script from "./LeagueModal.vue?vue&type=script&lang=js&"
export * from "./LeagueModal.vue?vue&type=script&lang=js&"
import style0 from "./LeagueModal.vue?vue&type=style&index=0&id=1f702d46&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports